/**
 * Целевые события рекламных счетчиков.
 *
 * Список общий для пикселя VK Рекламы и Яндекс Метрики: одно действие игрока —
 * одно имя цели в обоих кабинетах. Держать два списка нельзя, они разъедутся
 * при первом же добавлении, а разъехавшиеся имена ломают не отчет, а
 * ОПТИМИЗАЦИЮ кампаний — по цели, которой в кабинете нет, автостратегия
 * обучаться не будет.
 *
 * Каждое имя отсюда должно быть заведено целью в обоих кабинетах:
 * VK Реклама — вручную, Яндекс Метрика — «Цель: JavaScript-событие» с
 * идентификатором, равным имени.
 */
export const AD_GOALS = {
  // Аккаунт создан (первый вход нового игрока)
  REGISTRATION: 'registration',
  // Вход в аккаунт, включая автоматический по сохраненной сессии
  LOGIN: 'login',
  TUTORIAL_STARTED: 'tutorial_started',
  TUTORIAL_CHAPTER_COMPLETED: 'tutorial_chapter_completed',
  MATCH_STARTED: 'match_started',
  MATCH_FINISHED: 'match_finished',
  RANKED_MATCH_STARTED: 'ranked_match_started',
  // Попытка покупки премиума или кристаллов (покупка еще не подключена)
  PURCHASE_INTENT: 'purchase_intent',
  // Вступительные слайды до авторизации — верх воронки рекламного трафика:
  // человек долистал питч и нажал «Играть» еще до того, как стал пользователем
  INTRO_SLIDE_VIEW: 'intro_slide_view',
  INTRO_NEXT_CLICK: 'intro_next_click',
  INTRO_PLAY_CLICK: 'intro_play_click',
  // Приложение (PWA) установлено: событие браузера appinstalled. Приходит
  // только в Chromium (Android Chrome, десктопные Chrome и Edge, Samsung
  // Internet) — в iOS Safari установки «на экран Домой» браузер не сообщает
  APP_INSTALLED: 'app_installed',
  // Первый вход через установленное приложение — подтвержден сервером
  // (выдачей награды, см. /api/users/me/app-install-reward). Единственный
  // сигнал установки на iOS и признак того, что приложением пользуются
  APP_FIRST_LAUNCH: 'app_first_launch',
};
